module.exports = __webpack_public_path__ + "img/phone_1.b5a6f6f8.png";